import { ApiClient } from "@common/network/client";
import { IApiClient } from "@common/network/interfaces";
import { getConfig } from "@config/index";

import {
  fetchProfilePic, 
  uploadFormFile,  
  uploadFormFiles,
  uploadFormLogo,
  uploadProfilePic,
} from "../apis/urls";
import { IUploadFormFilesDataActionPayload } from "@common/redux/upload/interface";

const ENDPOINTS = {
  uploadProfilePic: () => uploadProfilePic,
  fetchProfilePic: () => fetchProfilePic,
  uploadFormFile: () => uploadFormFile, 
  uploadFormFiles: () => uploadFormFiles,
  uploadFormLogo: () => uploadFormLogo,
};
class UploadFileRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }

  public uploadProfilePic = async (data: any) => {
    const payload = new FormData();
    payload.append("file", data.file, data.file.name);
    const result = await this.apiClient.post(
      ENDPOINTS.uploadProfilePic(),
      payload,
      {}
    );
    return await result;
  };

  public fetchProfilePic = async (data: any,applicationId?: string) => {
    const params = { filePath: data , applicationId:applicationId};
    try{
      const result = await this.apiClient.get(
        ENDPOINTS.fetchProfilePic(),
        params,
        {
          baseURL: getConfig().APP_BE_BASE_URL,
        }
      );
           
      return await result;
    } catch(e) {
    }
  };
  public uploadFormFile = async (data: any) => {
    const payload = new FormData();
    payload.append("files", data?.file, data?.file?.name);
    payload.append("formId", data?.formId);
    const result = await this.apiClient.post(
      ENDPOINTS.uploadFormFile(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return await result;
  };





  public uploadFormFiles = async (data: any) => {
    const payload = new FormData(); 
    payload.append("formId", data?.formId);
    payload.append("applicationId", data?.applicationId);
    if (
      data.files &&
      data.files.length > 0
    ) {
      data.files.forEach((attachment) => {
        payload.append(`files`, attachment);
      });
    }
    const result = await this.apiClient.post(
      ENDPOINTS.uploadFormFiles(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return await result;
  };
  public uploadFormLogo = async (data: any) => {
    const payload = new FormData();
    payload.append("files", data?.file, data?.file?.name);
    payload.append(
      "request",
      JSON.stringify({
        location: "logo",
        data: { formId: data?.formId },
      })
    );
    try {
      const result = await this.apiClient.post(
        ENDPOINTS.uploadFormLogo(),
        payload,
        {},
        {
          baseURL: getConfig().APP_BE_BASE_URL,
        }
      );

      return await result;
    } catch (error) {
      console.log(error);
      return error;
    }
  };
}

const UploadFilesRepository = new UploadFileRepository(ApiClient);

export { UploadFilesRepository };
